import React from 'react';

export default function CardWisata() {
  return (
    <div className="flex flex-col font-[Rubik] border rounded px-7 py-8 bg-white">
      <p className="md:text-2xl text-xl text-black font-medium">Objek Wisata Guci</p>
      <div className="flex items-center">
        <img src="/assets/images/location.svg" alt="location" />
        <p className="md:text-lg text-sm text-[#666666] mx-4">Bumijawa, Tegal</p>
        <button className="bg-button border border-button rounded-[100px] px-5 py-2 md:text-base text-xs text-primary">
          Lihat di Map
        </button>
      </div>
      <div className="flex items-center">
        <img src="/assets/images/star.svg" alt="star" />
        <p className="text-[#FFCC16] mx-4 md:text-sm text-xs pt-1">600 Reviews</p>
      </div>
      <p className="md:text-lg text-sm text-[#999999] mt-8 mb-9">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tortor aliquam, congue mauris
        neque, interdum magna diam. Eu magna metus, mauris, ut nunc tellus suspendisse risus. Dictum
        id nisl, nulla malesuada feugiat hendrerit nullam erat pulvinar. Egestas mauris eget feugiat
        commodo sed eget non eget gravida. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Sed tortor aliquam, congue mauris neque, interdum magna diam. Eu magna metus, mauris, ut
        nunc tellus suspendisse risus. Dictum id nisl, nulla malesuada feugiat hendrerit nullam erat
        pulvinar. Egestas mauris eget feugiat commodo sed eget non eget gravida. consectetur
        adipiscing elit. Sed tortor aliquam, congue mauris neque, interdum magna diam. Eu magna
        metus, mauris, ut nunc tellus suspendisse risus.
      </p>
      <p className="text-[#666666] md:text-base text-sm">Fasilitas</p>
      <div className="grid md:grid-cols-3 grid-cols-2 items-center text-center">
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem Ipsum Sh
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem Ipsum
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem ipsum Sh
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem Ipsum Sh
        </div>
      </div>

      <p className="text-[#666666] mt-9 md:text-base text-sm">Fasilitas Umum Terdekat</p>
      <div className="grid md:grid-cols-3 grid-cols-2 items-center text-center">
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem Ipsum Sh
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem Ipsum
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem ipsum Sh
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem Ipsum
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem Ipsum Sh
        </div>
        <div className="border rounded-[100px] md:text-sm text-xs text-[#999999] border-[#ECECEC] px-4 py-2 mr-6 mt-4">
          Lorem ipsum
        </div>
      </div>
    </div>
  );
}
